import { PaymentType, PayCustomerActionResultCode, PayPortionState, PayCustomerItemStatus }
from '../shared/enums/smarthub-enums';

export class PayPortionActionInfo {
  constructor(
    public payId: string,
    public type: PaymentType,
    public itemNo: string,
    public reasonCode: string,
    public comment: string) { }
}

export class PayPortionActionResult {
  payId: string;
  type: PaymentType;
  itemNo: string;
  resultCode: PayCustomerActionResultCode;
  portionState: PayPortionState;
  targetState: PayPortionState;
  status: PayCustomerItemStatus;
}
